'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var create = require('./create.js');
var _delete = require('./delete.js');
var get = require('./get.js');



exports.createOneDataSource = create.createOneDataSource;
exports.deleteOneDataSource = _delete.deleteOneDataSource;
exports.getAllDataSources = get.getAllDataSources;
